exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-page-search-wrapper[data-v-954efa2a] {\r\n  margin-bottom: 16px;\n}\n.table-operator[data-v-954efa2a] {\r\n  margin-bottom: 16px;\n}\r\n", ""]);

// exports
